
/*
 * Created by alex@hackerbay.com on 4.2.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Col, Row} from "reactstrap";

const ACTION_BUTTON_COLORS = {
    RED: "button-red",
    GREY: "button-gray"
};

class ActionButton extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return <Col xs={12}>
            <Button
                className={"width-100 "+this.props.color}
                style={{height:"48px"}}
                onClick={this.props.onClick}>
                {i18n.t(this.props.textResource, this.props.textProps)}
            </Button>
        </Col>
    }
}

export default translate("translations")(ActionButton);
export {ACTION_BUTTON_COLORS}